import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export const CASHIERS = ['Agi', 'Albi', 'Lainnya'];
export const CASHIER_ENDPOINTS = ['Agi', 'Albi', 'Lainnya', 'Rekening'];

export function cashierBadgeClass(c) {
  switch (c) {
    case 'Agi':
      return 'bg-[rgba(var(--fpccs-primary-rgb),0.18)] text-[var(--fpccs-primary)] border-[rgba(var(--fpccs-primary-rgb),0.42)]';
    case 'Albi':
      return 'bg-[rgba(74,163,223,0.16)] text-[#4AA3DF] border-[rgba(74,163,223,0.40)]';
    case 'Lainnya':
      return 'bg-[var(--fpccs-surface-2)] text-[var(--fpccs-text-muted)] border-[var(--fpccs-border)]';
    default:
      return 'bg-white/5 text-muted-fpccs border-[var(--fpccs-border)]';
  }
}

export function CashierBadge({ cashier, cashier_other }) {
  if (!cashier) return <span className="text-xs text-subtle-fpccs">-</span>;
  const cls = cashierBadgeClass(cashier);
  const label = cashier === 'Lainnya' && cashier_other ? `Lainnya · ${cashier_other}` : cashier;
  return <span className={`inline-flex items-center text-[11px] px-1.5 py-0.5 rounded border whitespace-nowrap ${cls}`}>{label}</span>;
}

export default function CashierField({ value, otherValue, onChange, onOtherChange, label = 'Dibayar Oleh / Kasir', required = false, testid = 'field-cashier' }) {
  return (
    <div className="space-y-1.5">
      <Label className="text-xs text-muted-fpccs">{label}{required && ' *'}</Label>
      <Select value={value || ''} onValueChange={onChange}>
        <SelectTrigger data-testid={testid}><SelectValue placeholder="Pilih kasir" /></SelectTrigger>
        <SelectContent>
          {CASHIERS.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
        </SelectContent>
      </Select>
      {value === 'Lainnya' && (
        <Input
          data-testid={`${testid}-other`}
          value={otherValue || ''}
          onChange={(e) => onOtherChange?.(e.target.value)}
          placeholder="Nama kasir lainnya (opsional)"
          className="mt-1.5"
        />
      )}
    </div>
  );
}
